import { PiniaPluginContext } from 'pinia'

// Extend the options interface to include our custom persist property
declare module 'pinia' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface DefineStoreOptionsInPlugin<Id, S, G, A> {
    persist?: boolean
  }
}

/**
 * Pinia plugin that adds additional functionality to stores
 * - State persistence in localStorage (optional)
 * - Reset functionality to restore initial state
 * - Logging is disabled by default
 */
export function piniaPlugin({ store, options }: PiniaPluginContext) {
  // Add persistence capability
  if (options.persist) {
    // Hydrate the store when it's created
    const persistKey = `pinia-${store.$id}`
    const savedState = localStorage.getItem(persistKey)

    if (savedState) {
      try {
        store.$patch(JSON.parse(savedState))
      } catch {
        // Remove invalid state from localStorage
        localStorage.removeItem(persistKey)
      }
    }

    // Save state changes to localStorage
    store.$subscribe(() => {
      localStorage.setItem(persistKey, JSON.stringify(store.$state))
    })
  }

  // Add any additional plugins or functionality as needed
  return {
    // Additional properties can be added here
  }
}
